window.salesInvoiceCreditedForFormatter = function(value, row) {
    let html = '';
    if (row.credited_for) {
        html += row.credited_for;
    }
    return html;
}
